import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderFileExplorerComponent } from './file-explorer.component';
import { RappiderAlertModule } from '../alert/alert.module';
import { RappiderButtonModule } from '../button/button.module';
import { RappiderEditFormModule } from '../edit-form/edit-form.module';
import { RappiderListGridModule } from '../list-grid/list-grid.module';
import { RappiderParagraphModule } from '../paragraph/paragraph.module';
import { RappiderModalModule } from '../modal/modal.module';


@NgModule({
  declarations: [
    RappiderFileExplorerComponent
  ],
  imports: [
    CommonModule,
    RappiderEditFormModule,
    RappiderListGridModule,
    RappiderButtonModule,
    RappiderAlertModule,
    RappiderParagraphModule,
    RappiderModalModule
  ],
  exports: [
    RappiderFileExplorerComponent
  ]
})
export class RappiderFileExplorerModule { }
